import CustomTextInputProps from "../../services/models/customTextInputProps.mode";
import InputProps from "../../services/models/inputProps.model";
import MaskedInput from "react-text-mask";
import utils from "../../services/utils";
import ArrowUp from "../../assets/svg/ArrowUp";
import DropDownIcon from "../../assets/svg/DropdownIcon";
import LoadingSvg from "../../assets/svg/LoadingSVG";
import { Fragment } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";

function Input(props: InputProps): JSX.Element {
  if (props.inputmask) {
    return <MaskedInput {...props} mask={props.inputmask.mask} guide={false} />;
  }

  return (
    <div className="relative w-full">
      <input
        {...(props as React.InputHTMLAttributes<HTMLInputElement>)}
        className={twMerge(['font-sans placeholder:w-full placeholder:text-[#B1B8C3] w-full pr-8 text-xs sm:text-base truncate sm:pr-10 overflow-hidden whitespace-nowrap text-ellipsis', props.className])}
      />
      {/* <input
        {...(props as React.InputHTMLAttributes<HTMLInputElement>)}
        className={`font-sans placeholder:w-full placeholder:text-[#B1B8C3] w-full pr-8 text-sm truncate sm:pr-10 ${props.className}`}
      /> */}
      <div className="absolute right-3 inset-y-0 flex items-center">
        {props.searching && (
          <LoadingSvg
            stroke={"#18B5B7"}
            isSecondary
            className={"animate-spin -mt-1 mr-2"}
          />
        )}
        {props.suggestiveInput && (
          <Fragment>
            {props.suggestionVisible ? <ArrowUp /> : <DropDownIcon />}
          </Fragment>
        )}
      </div>
    </div>
  );
}

function CustomTextInput({
  labelInfo,
  containerClass,
  roundedInput,
  parentContainerClass,
  displayWhen,
  values,
  disabledWhen,
  ...props
}: Readonly<CustomTextInputProps>): JSX.Element | null {
  const { getFieldMeta } = props;
  const fieldName: any = props?.name && props?.name;
  const errorString = getFieldMeta?.(fieldName).error ?? "";
  const fieldTouched = getFieldMeta?.(fieldName).touched ?? "";
  const fieldValue: any = !!props?.value
    ? props.value
    : getFieldMeta?.(fieldName).value ?? "";
  const showError = errorString && fieldTouched;
  const disabled = !!disabledWhen
    ? utils.displayHandler(disabledWhen, values)
    : props.disabled;

  if (!!displayWhen) {
    if (!utils.displayHandler(displayWhen, values ?? {})) {
      return null;
    }
  }

  // Check if the input should be multiline
  const isMultiline =
    labelInfo?.inputId?.includes("notes") ||
    labelInfo?.inputId?.includes("comments");

  if (labelInfo?.label) {
    return (
      <div
        className={`my-3 w-full ${parentContainerClass} ${disabled && "cursor-not-allowed"
          }`}
      >
        <div
          className={`${roundedInput ? "" : "normalTextInputContainer"
            } ${containerClass} ${showError ? "border-requiredRed" : ""}`}
        >
          <label
            htmlFor={labelInfo.inputId}
            className={`inputLabel ${labelInfo.required
              ? "after:content-['*'] after:ml-1 after:text-requiredRed"
              : ""
              } ${showError ? "text-requiredRed" : ""} ${roundedInput ? "font-semibold" : ""
              }`}
          >
            {labelInfo.customLabel ? (
              <div dangerouslySetInnerHTML={{ __html: labelInfo.label }} />
            ) : (
              labelInfo.label
            )}
          </label>
          {isMultiline ? (
            <textarea
              id={labelInfo.inputId}
              disabled={disabled}
              className={`min-h-14 ${roundedInput ? "roundedTextInput" : "normalTextInput"
                } ${props.className} ${showError ? "border-requiredRed focus:border-requiredRed" : ""
                } ${disabled && "cursor-not-allowed"}`}
              {...(props as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
              value={fieldValue}
              rows={1} // Limit to 3 lines
              style={{ resize: "none" }} // Allow vertical resizing
            />
          ) : (
            <Input
              id={labelInfo.inputId}
              disabled={disabled}
              className={`${roundedInput ? "roundedTextInput" : "normalTextInput"
                } ${props.className} ${showError ? "border-requiredRed focus:border-requiredRed" : ""
                } ${disabled && "cursor-not-allowed"}`}
              {...props}
              value={fieldValue}
            />
          )}
        </div>
        {showError && (
          <h6 className="text-xs text-requiredRed mt-1">{errorString}</h6>
        )}
      </div>
    );
  }

  return (
    <div
      className={`my-3 w-full ${parentContainerClass} ${disabled && "cursor-not-allowed"
        }`}
    >
      {isMultiline ? (
        <textarea
          {...(props as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
          className={`min-h-14 ${roundedInput ? "roundedTextInput" : "normalTextInput"
            } ${props.className} ${showError ? "border-requiredRed focus:border-requiredRed" : ""
            }`}
          disabled={disabled}
          value={fieldValue}
          rows={1}
          style={{ resize: "none" }}
        />
      ) : (
        <Input
          {...props}
          className={`${roundedInput ? "roundedTextInput" : "normalTextInput"
            } ${props.className} ${showError ? "border-requiredRed focus:border-requiredRed" : ""
            }`}
          disabled={disabled}
          value={fieldValue}
        />
      )}
      {showError && (
        <h6 className="text-xs text-requiredRed mt-1">{errorString}</h6>
      )}
    </div>
  );
}

export default CustomTextInput;
